import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SingleComponent } from './single.component';
import { moduleConfigFunc, TnxSharedModule } from 'tnx-shared';
import { SingleRoutes } from './single.routing';
import { SingleFormComponent } from './single-form/single-form.component';

export function declaration() {
  return [SingleComponent, SingleFormComponent];
}

@NgModule({
  imports: [
    TnxSharedModule
  ],
  declarations: declaration(),
  exports: declaration()
})
export class SingleModule {
  static forRoot(config?: any): any {
    return {
      ngModule: TnxSharedModule,
      providers: [
        {
          provide: moduleConfigFunc,
          useValue: config
        }
      ]
    };
  }
}

@NgModule({
  imports: [SingleModule, SingleRoutes],
  exports: [SingleModule]
})
export class SingleWithRouteModule {
  static forRoot(config?: any): any {
    return {
      ngModule: TnxSharedModule,
      providers: [
        {
          provide: moduleConfigFunc,
          useValue: config
        }
      ]
    };
  }
}
